<template>
  <div>
    <b-row class="justify-content-end d-flex flex-wrap">
      <ButtonsFormVue
        :disable-form="disableForm"
        :loading-button="loading"
        :permission-insert="verificarPermissao('ROLE_PROFISSIONAL')"
        :permission-edit="verificarPermissao('ROLE_PROFISSIONAL')"
        @save="salvar"
        @edit="editar"
        @cancel="beforeCancelar"
      />
    </b-row>
    <app-collapse
      v-for="procedimento in procedimentoDataEdit.procedimentos"
      :key="procedimento.id"
      type="margin"
    >
      <app-collapse-item :is-visible="true" :title="procedimento.descricao">
        <b-row v-if="!hasCamposConfigurados(procedimento)">
          <b-col cols="12">
            <p class="text-muted">Nenhum campo configurado</p>
          </b-col>
        </b-row>
        <b-row>
          <b-col
            v-for="campo in procedimento.campoAdicionais"
            :key="campo.id"
            cols="12"
            :sm="campoColSize(campo)"
          >
            <b-form-group v-if="isCampoString(campo)" :label="campo.nome">
              <b-form-input
                :id="'id_' + campo.id"
                v-model="campo.valor"
                type="text"
                :disabled="disableForm"
              />
            </b-form-group>

            <b-form-group v-if="isCampoTexto(campo)" :label="campo.nome">
              <quill-editor
                :id="'id_' + campo.id"
                v-model="campo.valor"
                :options="editorOptions"
                :disabled="disableForm"
                :class="{ 'ql-disabled': disableForm }"
              />
            </b-form-group>

            <b-form-group v-if="isCampoNumerico(campo)" :label="campo.nome">
              <b-form-input
                :id="'id_' + campo.id"
                v-model="campo.valor"
                type="number"
                :disabled="disableForm"
              />
            </b-form-group>

            <b-form-group v-if="isCampoData(campo)" :label="campo.nome">
              <flat-pickr
                :id="'id_' + campo.id"
                v-model="campo.valor"
                name="fieldDate"
                class="form-control"
                :config="flatPickrConfig"
                :readonly="disableForm"
                :disabled="disableForm"
              />
            </b-form-group>

            <b-form-group v-if="isCampoBoolean(campo)" :label="campo.nome">
              <b-form-checkbox
                :id="'id_' + campo.id"
                v-model="campo.valor"
                name="check-button"
                :value="true"
                :unchecked-value="false"
                :disabled="disableForm"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </app-collapse-item>
    </app-collapse>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
} from "bootstrap-vue";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import flatPickr from "vue-flatpickr-component";
import mixinsGlobal from "@/mixins";
import { quillEditor } from "vue-quill-editor";
import ButtonsFormVue from "@/layouts/components/ButtonsForm.vue";

const INACTIVITY_TIMEOUT = 3 * 60 * 1000;
const FIELD_TYPES = {
  STRING: "STRING",
  TEXTO: "TEXTO",
  INTEGER: "INTEGER",
  DECIMAL: "DECIMAL",
  DATA: "DATA",
  BOOLEAN: "BOOLEAN",
};
const AUTO_SAVE_INTERVAL = 10000;

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    flatPickr,
    quillEditor,
    AppCollapse,
    AppCollapseItem,
    ButtonsFormVue,
  },
  mixins: [mixinsGlobal],
  props: {
    procedimentoData: {
      type: [Object, Array],
      default: () => ({}),
    },
    grupo: {
      type: Number,
      required: true,
    },
    create: {
      type: Boolean,
      required: true,
    },
    procedimentoId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      disableForm: true,
      inactivityTimer: null,
      inactivityTimeout: INACTIVITY_TIMEOUT,
      lastActivity: Date.now(),
      procedimentoDataEdit: {
        id: this.procedimentoId || null,
        atendimento: null,
        grupoProcedimento: this.grupo,
        procedimentos: [],
      },
      editorOptions: {
        theme: "snow",
        modules: {
          toolbar: [
            ["bold", "italic", "underline"],
            [{ list: "ordered" }, { list: "bullet" }],
            ["clean"],
          ],
        },
      },
      flatPickrConfig: {
        altInput: true,
        altFormat: "d/m/Y",
        enableTime: false,
        dateFormat: "Y-m-d\TH:i:ss\Z",
      },
    };
  },
  computed: {
    ...mapState("atendimentoProfissionalModule", {
      atendimento: (state) => state.atendimento,
    }),
    hasCamposConfigurados() {
      return (procedimento) =>
        procedimento.campoAdicionais && procedimento.campoAdicionais.length > 0;
    },
    isCampoTexto() {
      return (campo) => campo.tipo === FIELD_TYPES.TEXTO;
    },
    isCampoString() {
      return (campo) => campo.tipo === FIELD_TYPES.STRING;
    },
    isCampoNumerico() {
      return (campo) =>
        campo.tipo === FIELD_TYPES.INTEGER ||
        campo.tipo === FIELD_TYPES.DECIMAL;
    },
    isCampoData() {
      return (campo) => campo.tipo === FIELD_TYPES.DATA;
    },
    isCampoBoolean() {
      return (campo) => campo.tipo === FIELD_TYPES.BOOLEAN;
    },
    campoColSize() {
      return (campo) => (this.isCampoTexto(campo) ? "12" : "6");
    },
  },
  mounted() {
    this.cloneObjectOriginal();
  },
  methods: {
    autoSave() {
      this.salvar(true);
    },
    async salvar(autoSave = false) {
      this.loading = !autoSave;

      try {
        const action = this.create
          ? "atendimentoProfissionalModule/save"
          : "atendimentoProfissionalModule/editProcedimento";

        const response = await this.$store.dispatch(
          action,
          this.procedimentoDataEdit,
        );

        if (this.hasResponseError(response)) {
          this.MensagemError("Editar", "Falha ao editar!");
          return;
        }

        this.handleSaveSuccess(autoSave, response);
      } catch (error) {
        this.MensagemError("Editar", "Falha ao salvar!");
        console.error("Error saving procedimento:", error);
      } finally {
        this.loading = false;
      }
    },
    hasResponseError(response) {
      return (
        response.response &&
        response.response.data &&
        response.response.data.error
      );
    },
    handleSaveSuccess(autoSave, response) {
      if (autoSave) {
        this.showMessageSuccess("Salvar", "Salvo automaticamente com sucesso!");
        this.resetInactivityTimer();
      } else {
        this.showMessageSuccess("Editar", "Editado com sucesso!");
        this.disableForm = true;
        this.$emit("save", response.data.procedimentos);
        this.clearInactivityTimer();
      }
    },
    resetInactivityTimer() {
      this.lastActivity = Date.now();
    },
    startInactivityTimer() {
      this.resetInactivityTimer();
      this.inactivityTimer = setInterval(() => {
        const currentTime = Date.now();
        const timeSinceLastActivity = currentTime - this.lastActivity;

        if (
          timeSinceLastActivity >= this.inactivityTimeout &&
          !this.disableForm
        ) {
          this.autoSave();
        }
      }, AUTO_SAVE_INTERVAL);
    },
    editar() {
      this.disableForm = false;
      this.cloneObjectOriginal();
      this.startInactivityTimer();
    },
    beforeCancelar() {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxConfirm("Deseja realmente sair do procedimento?", {
          title: "Confirmação",
          size: "sm",
          okVariant: "primary",
          okTitle: "Sim",
          cancelTitle: "Não",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          this.boxTwo = value;
          if (value) {
            this.cancelar();
          }
        });
    },
    clearInactivityTimer() {
      if (this.inactivityTimer) {
        clearInterval(this.inactivityTimer);
        this.inactivityTimer = null;
      }
    },
    cancelar() {
      this.disableForm = true;
      this.loading = false;
      this.clearInactivityTimer();
      this.cloneObjectOriginal();
    },
    cloneObjectOriginal() {
      this.procedimentoDataEdit.id = this.procedimentoId || null;
      this.procedimentoDataEdit.atendimento = this.$route.params.id;
      this.procedimentoDataEdit.grupoProcedimento = this.grupo;
      this.procedimentoDataEdit.procedimentos = JSON.parse(
        JSON.stringify(this.procedimentoData),
      );
    },
  },
  watch: {
    procedimentoData: {
      handler() {
        this.cloneObjectOriginal();
      },
      deep: true,
    },
    procedimentoId() {
      this.cloneObjectOriginal();
    },
    create() {
      this.cloneObjectOriginal();
    },
  },
  mounted() {
    this.cloneObjectOriginal();
  },
};
</script>

<style lang="scss" scoped>
.ql-disabled {
  opacity: 0.6;
  pointer-events: none;
}
</style>
